module.exports = __webpack_public_path__ + "static/media/banesco-off-app-provider-icon.8e6c085e.svg";